/*
==========================================================
CREATE ACCESS REQUEST CONTRACT
==========================================================

Defines the data required to create a new
platform access request.

==========================================================
*/

const createAccessRequestContract = {

  /*
  ==========================================================
  PERSONAL
  ==========================================================
  */

  displayName: "",

  /*
  ==========================================================
  ACCOUNT
  ==========================================================
  */

  email: ""

};

export default createAccessRequestContract;